import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  return (
    <header className="main-nav">
      <Link to="/" className="nav-logo">TheaMou</Link>
      <nav className="nav-menu">
        <Link to="/about-us">About Us</Link>
        <span className="nav-divider">|</span>
        <Link to="/pame-brosta">PAME Brosta</Link>
        <span className="nav-divider">|</span>
        <Link to="/olympic-angels">Olympic Angels by Theo</Link>
      </nav>
    </header>
  );
};

export default Header;
